import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, reactive } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  setup(__props, { expose: __expose }) {

const dialog = ref(false)
const message = ref('')
const title = ref('')
const options = reactive({
  color: '',
  width: 320,
  zIndex: 200
})

let resolvePromise: ((value: boolean) => void) | null = null

const open = (dialogTitle = '', dialogMessage = '', dialogOptions = {}) => {
  dialog.value = true
  title.value = dialogTitle
  message.value = dialogMessage
  Object.assign(options, dialogOptions)
  return new Promise<boolean>((resolve) => {
    resolvePromise = resolve
  })
}

const agree = () => {
  if (resolvePromise) resolvePromise(true)
  dialog.value = false
}

const cancel = () => {
  if (resolvePromise) resolvePromise(false)
  dialog.value = false
}

__expose({
  open
})

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    persistent: "",
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
    "max-width": options.width,
    style: _normalizeStyle({ zIndex: options.zIndex }),
    onKeydown: _withKeys(cancel, ["esc"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, {
            color: options.color
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(title.value), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["color"]),
          _withDirectives(_createVNode(_component_v_card_text, { class: "p-4" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(message.value), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 512 /* NEED_PATCH */), [
            [_vShow, !!message.value]
          ]),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "primary-darken-1",
                text: "",
                onClick: agree
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("OK", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_v_btn, {
                color: "grey",
                text: "",
                onClick: cancel
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("キャンセル", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "max-width", "style"]))
}
}

})